import EstimateCreateContainer from "@legacy/estimates/EstimateCreateContainer"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { ESTIMATES_ROUTES } from "@routes/estimates"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function EstimateEdit() {
    const estimateId = window.ESTIMATE_ID
    const isDraft = window.ESTIMATE_IS_DRAFT

    const [detailsRoute] = useSlugExtractor([ESTIMATES_ROUTES.DETAILS], estimateId)
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const detailsBackDestination = hasPermission("estimates_view_permission", PERMISSION_LEVEL.FULL)
        ? detailsRoute
        : undefined

    return (
        <AppFrame.Root navigationType="inner">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageInnerTitle
                            label={isDraft ? "New Estimate" : "Edit Estimate"}
                            backDestination={detailsBackDestination}
                        />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <EstimateCreateContainer formMode="EDIT_ESTIMATE" addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
